import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Badge from 'react-bootstrap/Badge';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import 'react-json-pretty/themes/monikai.css';
import ReactTable from 'react-table-6';
import './styles.css';
import DeleteModal from './modals/deleteModal';
import EditUserModal from './modals/editUserModal';
import AddUserModal from './modals/addUserModal';
import UserInfoModal from './modals/userInfoModal';
import AddPhysicianModal from './modals/add-physician/';
import ApproveAccessModal from './modals/approveAccessModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as UserActions from 'bv360/redux/actions/user';
import isEmpty from 'lodash.isempty';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'shared/components/spinner/spinner';

class PracticeUserManagement extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      deleteModalOpen: false,
      editUserModalopen: false,
      addPhysicianModalopen: false,
      userInfoModalOpen: false,
      selectedUser: {},
      // Access Requests state
      activeTab: 'users',
      accessRequests: [],
      loadingAccessRequests: false,
      errorAccessRequests: null,
      requestStatusFilter: 'pending',
      pendingCount: 0,
      // Approve modal state
      approveModalOpen: false,
      selectedAccessRequest: null,
      selectedReplacementId: null
    };
  }

  formatDate(value) {
    if (!value) return '';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      if (typeof value === 'string') {
        const isoCandidate = value
          .replace(' ', 'T')
          .replace(/([+-]\d{2})$/, '$1:00');
        const fallbackParsed = new Date(isoCandidate);
        if (!Number.isNaN(fallbackParsed.getTime())) {
          return fallbackParsed.toLocaleDateString();
        }
      }
      return value;
    }
    return parsed.toLocaleDateString();
  }

  columns = [
    {
      Header: 'First Name',
      id: 'firstName',
      accessor: 'user.first_name',
      minWidth: 30
    },
    {
      Header: 'Last Name',
      id: 'lastName',
      accessor: 'user.last_name',
      minWidth: 50
    },
    {
      Header: 'User Name',
      id: 'userName',
      accessor: 'user.username',
      minWidth: 70
    },
    {
      Header: 'Role(s)',
      id: 'role',
      accessor: 'compiled_roles',
      minWidth: 60
    },
    {
      Header: 'Created Date',
      id: 'createdDate',
      accessor: 'user.date_joined',
      minWidth: 60,
      Cell: row => this.formatDate(row.value)
    },
    {
      Header: 'Last Login Date',
      id: 'lastLoginDate',
      accessor: 'user.last_login',
      minWidth: 60,
      Cell: row => this.formatDate(row.value)
    },
    {
      Header: 'Delete',
      id: 'delete',
      minWidth: 20,
      Cell: row => {
        return row.original.user && this.props.user.username !== row.original.user.username ? (
          <button onClick={() => this.deleteModalToggle(row.original)} className="btn btn-primary">
            <i className="fa fa-trash" />
          </button>
        ) : null;
      }
    },
    {
      Header: 'Edit',
      id: 'edit',
      minWidth: 20,
      Cell: row => {
        return (
          <button
            // row.original is the selectedUser
            onClick={() => this.editUserModalToggle(row.original)}
            className="btn btn-primary"
          >
            <i className="fa fa-edit" />
          </button>
        );
      }
    }
  ];
  re = /^[0-9]*$/;
  isAllNumbers(val) {
    return this.re.test(val);
  }

  getPracticeIdFromUrl() {
    try {
      const search = typeof window !== 'undefined' ? window.location.search : '';
      const params = new URLSearchParams(search);
      return params.get('practice_id') || null;
    } catch (e) {
      return null;
    }
  }

  getSelectedPractice() {
    try {
      const practiceIdFromUrl = this.getPracticeIdFromUrl();

      if (practiceIdFromUrl && this.props.practices && this.props.practices.length) {
        // Try to find the practice with the matching ID (convert both to numbers for comparison)
        const selectedPractice = this.props.practices.find(
          p => String(p.id) === String(practiceIdFromUrl)
        );
        if (selectedPractice) {
          return selectedPractice;
        }
      }

      // Fallback to first practice
      return this.props.practices && this.props.practices.length ? this.props.practices[0] : null;
    } catch (e) {
      // Fallback to first practice on error
      return this.props.practices && this.props.practices.length ? this.props.practices[0] : null;
    }
  }

  componentDidMount() {
    const isAdmin = this.props.user?.is_superuser || false;
    const isCustomerService = this.props.user?.groups?.includes('BV360 Customer Service') || false;
    const isAdminOrCS = isAdmin || isCustomerService;

    if (!isAdminOrCS) {
      this.props.actions.getPractices({}, false);
    }

    // add the new view modal if the user is a superuser on mount
    if (this.props.user?.is_superuser || this.props.user?.groups.includes('BV360 Customer Service'))
      this.columns.push({
        Header: 'CoPilot',
        id: 'CoPilot',
        minWidth: 20,
        Cell: row => {
          return (
            <button
              // row.original is the selectedUser
              onClick={() => this.userInfoModalToggle(row.original)}
              className="btn btn-primary"
            >
              <i className="fa fa-search" />
            </button>
          );
        }
      });
    // Preload pending count so the tab badge is correct on initial load
    this.loadPendingCount();

    // If query param access-tab=true, switch to Access Requests tab on load
    try {
      const search = typeof window !== 'undefined' ? window.location.search : '';
      const params = new URLSearchParams(search);
      const accessTab = params.get('access-tab');
      if (String(accessTab).toLowerCase() === 'true') {
        this.setState({ activeTab: 'requests' }, () => this.loadAccessRequests('pending'));
      }
    } catch (e) {
      // no-op
    }
  }

  componentDidUpdate(prevProps) {
    // When practices load, refresh pending count so the badge is correct
    // (handles case when practice_id is not in URL and we need getSelectedPractice)
    const practicesJustLoaded =
      !prevProps.practices?.length && this.props.practices?.length;
    if (practicesJustLoaded) {
      this.loadPendingCount();
    }
  }

  loadAccessRequests = async (status = this.state.requestStatusFilter) => {
    try {
      this.setState({ loadingAccessRequests: true, errorAccessRequests: null });
      const practiceId =
        this.getPracticeIdFromUrl() || this.getSelectedPractice()?.id;
      const practiceParam = practiceId ? `&practiceId=${practiceId}` : '';
      const res = await fetch(
        `/mybv360/api/access-requests?status=${encodeURIComponent(status)}${practiceParam}`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );
      const json = await res.json();
      if (!res.ok) throw new Error(json?.error || 'Failed to load access requests');
      this.setState({ accessRequests: json.data || [], loadingAccessRequests: false });
      // Keep the pending badge accurate when filter is pending
      if ((status || '') === 'pending') {
        this.setState({ pendingCount: (json.data || []).length });
      }
    } catch (e) {
      this.setState({ errorAccessRequests: e.message, loadingAccessRequests: false });
    }
  };

  loadPendingCount = async () => {
    try {
      const practiceId =
        this.getPracticeIdFromUrl() || this.getSelectedPractice()?.id;
      const practiceParam = practiceId ? `&practiceId=${practiceId}` : '';
      const res = await fetch(
        `/mybv360/api/access-requests?status=pending${practiceParam}`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );
      const json = await res.json();
      if (!res.ok) throw new Error(json?.error || 'Failed to load pending count');
      this.setState({ pendingCount: (json.data || []).length });
    } catch (e) {
      this.setState({ pendingCount: 0 });
    }
  };

  onSelectTab = key => {
    this.setState({ activeTab: key }, () => {
      if (key === 'requests') {
        this.loadAccessRequests();
      }
    });
  };

  setRequestStatusFilter = status => {
    this.setState({ requestStatusFilter: status }, () => this.loadAccessRequests(status));
  };

  approveAccessRequest = row => {
    // Open the approval modal with the selected access request
    this.setState({
      approveModalOpen: true,
      selectedAccessRequest: row.original
    });
  };

  toggleApproveModal = () => {
    this.setState({
      approveModalOpen: !this.state.approveModalOpen,
      selectedAccessRequest: this.state.approveModalOpen ? null : this.state.selectedAccessRequest
    });
  };

  handleApprove = async (accessRequest, roleId) => {
    try {
      const res = await fetch('/mybv360/api/access-requests/approve', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          userEmail: accessRequest.requester_email,
          roleId: roleId
        })
      });
      if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json?.error || 'Failed to approve access request');
      }
      // Refresh all three: access requests, practice users, and pending count
      this.loadAccessRequests();
      this.loadPendingCount();
      const selectedPractice = this.getSelectedPractice();
      if (selectedPractice?.id) {
        this.props.actions.getPracticeUsers(selectedPractice.id);
      }
    } catch (e) {
      // Re-throw the error so the modal can display it
      throw e;
    }
  };

  denyAccessRequest = async row => {
    try {
      const reason = window.prompt('Optional: Enter a reason for denial (or leave blank)');
      const res = await fetch('/mybv360/api/access-requests/deny', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id: row.original.id, reason })
      });
      if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json?.error || 'Failed to deny access request');
      }
      this.loadAccessRequests();
      this.loadPendingCount();
    } catch (e) {
      alert(e.message);
    }
  };

  requestColumns = [
    { Header: 'First Name', id: 'reqFirst', accessor: 'requester_first_name', minWidth: 40 },
    { Header: 'Last Name', id: 'reqLast', accessor: 'requester_last_name', minWidth: 40 },
    { Header: 'Email', id: 'reqEmail', accessor: 'requester_email', minWidth: 80 },
    { Header: 'Requested', id: 'reqAt', accessor: 'requested_at', minWidth: 80 },
    { Header: 'Status', id: 'reqStatus', accessor: 'status', minWidth: 40 },
    {
      Header: 'Actions',
      id: 'reqActions',
      minWidth: 60,
      Cell: row => {
        const isPending = String(row?.original?.status).toLowerCase() === 'pending';
        if (!isPending) return null;
        return (
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => this.approveAccessRequest(row)} className="btn btn-success">
              Approve
            </button>
            <button onClick={() => this.denyAccessRequest(row)} className="btn btn-outline-danger">
              Deny
            </button>
          </div>
        );
      }
    }
  ];

  editUserModalToggle = (selectedUser = this.state.selectedUser) => {
    this.props.actions.clearCopilotDetails();
    this.setState({
      editUserModalOpen: !this.state.editUserModalOpen,
      selectedUser: selectedUser
    });
  };

  userInfoModalToggle = (selectedUser = this.state.selectedUser) => {
    this.state.userInfoModalOpen
      ? this.props.actions.clearCopilotDetails()
      : this.props.actions.getUserCopilotDetails(selectedUser);
    this.setState({
      userInfoModalOpen: !this.state.userInfoModalOpen,
      selectedUser: selectedUser
    });
  };

  addPhysicianModalToggle = () => {
    this.setState({
      addPhysicianModalopen: !this.state.addPhysicianModalopen
    });
  };

  deleteModalToggle = (selectedUser = this.state.selectedUser) => {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen,
      selectedUser: selectedUser,
      selectedReplacementId: null
    });
  };

  deleteHandler = () => {
    const { selectedUser, selectedReplacementId } = this.state;
    this.setState({ deleteModalOpen: false, selectedReplacementId: null });
    if (selectedReplacementId) {
      this.props.actions.editPracticeUser({ id: selectedReplacementId, is_admin: true });
    }
    this.props.actions.deactivateUser(selectedUser.id);
  };

  isLastAdminBeingRemoved = selectedUser => {
    if (!selectedUser || !selectedUser.is_admin) return false;
    const adminCount = (this.props.practice_users || []).filter(u => u.is_admin).length;
    return adminCount === 1;
  };

  render() {
    if (this.props.loading) return <Spinner />;

    const isSystemsAdmin = this.props.user?.is_superuser || false;
    const isBV360CustomerService =
      this.props.user?.groups?.includes('BV360 Customer Service') || false;

    // add the new view column only if the user is a superuser

    if (this.props.practices.length === 0 && this.props.loading === false) {
      if (isSystemsAdmin || isBV360CustomerService) {
        return (
          <Container style={{ paddingTop: '120px', paddingBottom: '8rem' }} fluid={false}>
            <h1>
              {' '}
              The current user is not associated with any practice. Please first search for and
              select a practice.{' '}
            </h1>{' '}
          </Container>
        );
      } else {
        return (
          <Container style={{ paddingTop: '120px', paddingBottom: '8rem' }} fluid={false}>
            <h1> The current user is not associated with any practice.</h1>{' '}
          </Container>
        );
      }
    } else if (
      isEmpty(this.props.practice_users[0]) &&
      !isSystemsAdmin &&
      !isBV360CustomerService &&
      this.props.loading === false
    ) {
      return (
        <Container style={{ paddingTop: '120px', paddingBottom: '8rem' }} fluid={false}>
          <h1> The current user is not the administrator of any practice.</h1>{' '}
        </Container>
      );
    }
    // check if the first entry in this.props.practice_users is an empty object
    const selectedPractice = this.getSelectedPractice();
    return (
      <Container style={{ paddingTop: '120px', paddingBottom: '8rem' }} fluid={false}>
        <Card>
          <Card.Body>
            <div style={{ fontSize: '20px' }}>
              Practice:{' '}
              {selectedPractice && selectedPractice.name_edited
                ? selectedPractice.name_edited
                : selectedPractice?.name || 'N/A'}{' '}
            </div>
            <div style={{ fontSize: '13px' }}>
              *Blue Highlight Indicates Not Yet Invited to MyBV360{' '}
            </div>
          </Card.Body>
        </Card>
        <Row>
          <Col>
            <Alert variant="danger" show={!!this.props.error}>
              <i className="fa fa-fw fa-exclamation-triangle" /> {this.props.error}
            </Alert>
          </Col>
        </Row>
        <Tabs
          id="practice-user-management-tabs"
          activeKey={this.state.activeTab}
          onSelect={this.onSelectTab}
          className="mb-3 pum-tabs"
        >
          <Tab eventKey="users" title="Users">
            <ReactTable
              data={
                isEmpty(this.props.practice_users[0])
                  ? this.props.practice_users.slice(1)
                  : this.props.practice_users
              }
              minRows={10}
              columns={this.columns}
              className="-striped -highlight"
              showPagination={true}
              getTdProps={() => ({
                style: { display: 'flex', justifyContent: 'center', alignItems: 'center' }
              })}
              getTrProps={(state, rowInfo) => {
                if (rowInfo?.row) {
                  return {
                    style: {
                      background: this.isAllNumbers(rowInfo.row.userName) ? '#d4e4ff' : null
                    }
                  };
                } else {
                  return {};
                }
              }}
            />
            <Button
              type="button"
              style={{ position: 'relative', top: '20px', left: '45%' }}
              onClick={() => this.props.actions.addUserModalToggle()}
            >
              Add Staff
            </Button>
            <Button
              type="button"
              style={{ position: 'relative', top: '20px', left: '45%' }}
              onClick={() => this.addPhysicianModalToggle()}
            >
              Add Provider
            </Button>
          </Tab>
          <Tab
            eventKey="requests"
            title={
              <span>
                Access Requests <Badge bg="secondary">{this.state.pendingCount}</Badge>
              </span>
            }
          >
            <div style={{ marginBottom: 12 }}>
              <span>Status:&nbsp;</span>
              {['pending', 'approved', 'denied', ''].map(s => (
                <Button
                  key={s || 'all'}
                  size="sm"
                  variant={this.state.requestStatusFilter === s ? 'primary' : 'outline-primary'}
                  style={{ marginRight: 8 }}
                  onClick={() => this.setRequestStatusFilter(s || '')}
                >
                  {s || 'all'}
                </Button>
              ))}
            </div>
            {this.state.errorAccessRequests && (
              <Alert variant="danger" show={true}>
                <i className="fa fa-fw fa-exclamation-triangle" /> {this.state.errorAccessRequests}
              </Alert>
            )}
            {this.state.loadingAccessRequests ? (
              <Spinner />
            ) : (
              <ReactTable
                data={this.state.accessRequests}
                minRows={10}
                columns={this.requestColumns}
                className="-striped -highlight"
                showPagination={true}
              />
            )}
          </Tab>
        </Tabs>
        <DeleteModal
          show={this.state.deleteModalOpen}
          onHide={this.deleteModalToggle}
          deleteHandler={this.deleteHandler}
          isLastAdmin={this.isLastAdminBeingRemoved(this.state.selectedUser)}
          otherUsers={(this.props.practice_users || []).filter(
            u =>
              u.id &&
              u.user &&
              u.id !== this.state.selectedUser?.id &&
              !this.isAllNumbers(u.user.username)
          )}
          selectedReplacementId={this.state.selectedReplacementId}
          onSelectReplacement={id => this.setState({ selectedReplacementId: id })}
        />
        <EditUserModal
          show={this.state.editUserModalOpen}
          isAdmin={isSystemsAdmin}
          onHide={this.editUserModalToggle}
          selectedUser={this.state.selectedUser}
          currentUserUsername={this.props.user.username}
          loading={this.props.loading}
          loadingCoPilot={this.props.loadingCoPilot}
          copilotDetails={this.props.copilot_user_details}
          copilotDetailsError={this.props.copilot_user_details_error}
          isLastAdmin={this.isLastAdminBeingRemoved(this.state.selectedUser)}
          otherUsers={(this.props.practice_users || []).filter(
            u =>
              u.id &&
              u.user &&
              u.id !== this.state.selectedUser?.id &&
              !this.isAllNumbers(u.user.username)
          )}
        />
        <AddUserModal
          show={this.props.addUserModalOpen}
          onHide={this.props.actions.addUserModalToggle}
          currentUserUsername={this.props.user.username}
          requireFax={this.props.requireFax}
          practices={this.props.practices}
          loading={this.props.loading}
          error={this.props.error}
        />
        <AddPhysicianModal
          show={this.state.addPhysicianModalopen}
          onHide={this.addPhysicianModalToggle}
          error={null}
          loading={false}
          practices={this.props.practices}
          getpracticeusers={() => this.props.actions.getPracticeUsers(selectedPractice?.id)}
        />
        <UserInfoModal
          show={this.state.userInfoModalOpen}
          isAdmin={isSystemsAdmin}
          onHide={this.userInfoModalToggle}
          selectedUser={this.state.selectedUser}
          currentUserUsername={this.props.user.username}
          loading={this.props.loading}
          loadingCoPilot={this.props.loadingCoPilot}
          copilotDetails={this.props.copilot_user_details}
          copilotDetailsError={this.props.copilot_user_details_error}
        />
        <ApproveAccessModal
          show={this.state.approveModalOpen}
          onHide={this.toggleApproveModal}
          accessRequest={this.state.selectedAccessRequest}
          onApprove={this.handleApprove}
        />
      </Container>
    );
  }
}

export default connect(
  state => ({
    addUserModalOpen: state.user.addUserModalOpen,
    requireFax: state.user.requireFax,
    user: state.user.user,
    loading: state.user.loading,
    loadingCoPilot: state.user.loadingCoPilot,
    practice_users: state.user.practice_users,
    error: state.user.error,
    practices: state.user.practices,
    copilot_user_details: state.user.copilot_user_details,
    copilot_user_details_error: state.user.copilot_user_details_error
    // ssoComplete: state.user.ssoComplete
  }),
  dispatch => ({
    actions: {
      ...bindActionCreators(UserActions, dispatch)
    }
  })
)(PracticeUserManagement);
